import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { switchOff2Fa } from '@api/userProfile';

import { TMutateModalHandlers } from '@interfaces/common/handlers';
import { IResponseError } from '@interfaces/errors/apiErrors';
import { IDisable2FAValueDTO } from '@interfaces/user/dto/userProfileDTO';

import { DISABLE_2FA, USER_PROFILE } from '@constants/queryKeys';

export const useMutateDisable2Fa = ({ onSuccess, onError }: TMutateModalHandlers) => {
	const queryClient = useQueryClient();

	const {
		mutate: disable2Fa,
		isLoading: isLoadingDisable2Fa,
	} = useMutation<IDisable2FAValueDTO>({
		mutationKey: [DISABLE_2FA],
		mutationFn: switchOff2Fa,
		onSuccess: () => {
			if (onSuccess) onSuccess();

			return [queryClient.invalidateQueries([USER_PROFILE])];
		},
		onError: (err: IResponseError) => {
			if (onError) onError(err);
		},
	});

	return {
		disable2Fa,
		isLoadingDisable2Fa,
	};
};
